export default "__VITE_ASSET__34950df9__"